import { StoreAction } from '@shared/store/store-action.model';
import { StoreActionError } from '@shared/store/store-action-error.model';

import { UserCreateApiPayload } from '../models/user-create-api.model';
import { UserUpdateApiPayload } from '../models/user-update-api.model';

const USER_SCOPE = '[User]';
const API_SCOPE = `${ USER_SCOPE } API`;

export namespace UserActions {

  export class Register extends StoreAction<UserCreateApiPayload> {
    static override readonly type = `${ API_SCOPE } Register`;

    constructor(public override payload: UserCreateApiPayload) {
      super(payload);
    }
  }

  export class RegisterSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Register Success`;
  }

  export class RegisterFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Register Failed`;
  }

  export class GetMe extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get Me`;
  }

  export class GetMeSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get Me Success`;
  }

  export class GetMeFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get Me Failed`;
  }

  export class Update extends StoreAction<UserUpdateApiPayload> {
    static override readonly type = `${ API_SCOPE } Update`;

    constructor(public override payload: UserUpdateApiPayload) {
      super(payload);
    }
  }

  export class UpdateSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Update Success`;
  }

  export class UpdateFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Update Failed`;
  }

  export class Delete extends StoreAction {
    static override readonly type = `${ API_SCOPE } Delete`;
  }

  export class DeleteSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Delete Success`;
  }

  export class DeleteFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Delete Failed`;
  }

  export class ResetLoadedState extends StoreAction {
    static override readonly type = `${ USER_SCOPE } Reset Loaded State`;
  }

  export class ResetState extends StoreAction {
    static override readonly type = `${ USER_SCOPE } Reset State`;
  }
}
